import { createContext, useContext } from "react";

export type Theme = "dark" | "light";

export interface ThemeValue {
  theme: Theme;
  toggle: () => void;
}

export const ThemeContext = createContext<ThemeValue>({ theme: "dark", toggle: () => undefined });

export const useTheme = () => useContext(ThemeContext);
